import { pxToRem } from "@/util/common";
import { Image, Button, Toast } from "antd-mobile";
import { createUseStyles } from "react-jss";
import TermsPopup from "./comp/termsPopup";
import { useEffect, useRef, useState } from "react";
import { useMetaMask } from "@onyx-p/metamask-react";
import useRouter from "@/hooks/useRouter";
import { showGlobalLoading } from "@/components/globalLoading";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import {
	postUserLoginByConsole,
	postUserLoginByWallet,
	setAdminType,
	setToken,
	setUserInfo,
} from "@/redux/reducers/authSlice";
import { CreditsVault, loginByWalletData } from "@/api/type";
import { isEmpty, isString } from "lodash";
import API from "@/api";
import Web3 from "web3";
import useCustomTranslation from "@/hooks/useTranslation";
import CustomLanguage from "@/components/customLanguage";
import { useLocalStorage } from "@/util/Storage";
import useCenterPopup from "@/hooks/useCenterPopup";
import InvitationCode from "./comp/InvitationCode";

const Login: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { connect, status, ethereum } = useMetaMask();
	const { customNavigate, location } = useRouter();
	const { showLoading, hideLoading } = showGlobalLoading();
	const ApplyCenterPopup = useCenterPopup();
	const [termsChecked, setTermsChecked] = useState(false);
	const [termsVisible, setTermsVisible] = useState(false);
	const { search } = useSelector((state: RootState) => state.initialization);
	const isCredits = window.location.href.toLowerCase().includes(CreditsVault);
	console.log("isCredits", isCredits);
	const telegram = window.Telegram?.WebApp;
	const isTelegram = !!telegram?.initData;

	const invitationCode = useRef("");
	const nonce = useRef("");
	const connectedAddr = useRef("");

	useEffect(() => {
		dispatch(setAdminType(false));
	}, [dispatch]);

	const extractCodes = () => {
		const query = new URLSearchParams(search);
		const channelCode = query.get("c");
		const inviteCode = query.get("i");

		return { channelCode, inviteCode };
	};

	const login = async () => {
		if (!termsChecked) {
			Toast.show({
				content: t("PleaseBeforeConnecting"),
				position: "top",
			});
			return;
		}
		try {
			showLoading();

			if (isTelegram) {
				const originalHref = useLocalStorage.get("originalHref");
				if (originalHref) {
					window.location.replace(originalHref);
				} else {
					customNavigate("/", {
						replace: true,
					});
				}
				return;
			}

			if (status === "unavailable") {
				throw new Error(t("MetamaskUnavailable"));
			}

			const addressList = await connect();
			connectedAddr.current = addressList?.[0]?.toLowerCase() ?? "";
			if (isEmpty(connectedAddr.current)) {
				throw new Error(t("WalletEmpty"));
			}

			const nonceResponse: any = await API.members.postLoginNonce({
				walletAddress: connectedAddr.current,
			});
			if (nonceResponse?.code !== 0) {
				return;
			}
			nonce.current = nonceResponse.content?.data?.message;
			const isRegister = nonceResponse.content?.data?.isRegister;
			if (!isRegister) {
				ApplyCenterPopup.showPopup();
				return;
			}
			continueLogin();
		} catch (error: any) {
			const errorMsg = error?.message ?? error;
			if (isString(errorMsg) && !isEmpty(errorMsg)) {
				Toast.show({
					content: errorMsg as string,
					position: "top",
				});
			}
			console.error("login connectWallet", error);
		} finally {
			hideLoading();
		}
	};

	const continueLogin = async () => {
		try {
			showLoading();
			const signResult = await ethereum
				.request({
					method: "personal_sign",
					params: [
						Web3.utils.fromUtf8(nonce.current),
						connectedAddr.current,
					],
				})
				.catch(() => {
					throw new Error(t("SignatureFailure"));
				});

			const { channelCode } = extractCodes();
			const params: loginByWalletData = {
				walletAddress: connectedAddr.current,
				signMessage: nonce.current,
				signStr: signResult,
			};
			if (!isEmpty(channelCode)) {
				params.channelCode = channelCode!;
			}
			// 无效代码
			// if (!isEmpty(inviteCode)) {
			// 	params.inviteCode = inviteCode!;
			// }
			// 如果有邀请码，添加到登录参数中
			if (!isEmpty(invitationCode.current)) {
				params.inviteCode = invitationCode.current;
			}
			let response;
			if (isCredits) {
				response = await dispatch(postUserLoginByConsole(params));
			} else {
				response = await dispatch(postUserLoginByWallet(params));
			}
			const result = response.payload as any;
			if (result?.code === 0) {
				const data = result.content.data;
				dispatch(setUserInfo(data.user));
				dispatch(setToken(data.token));
				if (isCredits) {
					customNavigate("/vaultManage", {
						replace: true,
					});
				} else {
					customNavigate(`/game${location.search ?? ""}`, {
						replace: true,
					});
				}
			}

			// 如果有邀请码，添加到登录参数中
			if (!isEmpty(invitationCode.current)) {
				params.inviteCode = invitationCode.current;
			}

			// ... 继续执行后续登录代码 ...
		} catch (error: any) {
			const errorMsg = error?.message ?? error;
			if (isString(errorMsg) && !isEmpty(errorMsg)) {
				Toast.show({
					content: errorMsg as string,
					position: "top",
				});
			}
			console.error("continueLogin connectWallet", error);
		} finally {
			hideLoading();
		}
	};

	useEffect(() => {
		const { inviteCode } = extractCodes();
		invitationCode.current = inviteCode ?? "";
	}, []);
	return (
		<div className={classes.loginPage}>
			<div
				style={{
					position: "fixed",
					top: pxToRem(30),
					right: pxToRem(20),
				}}
			>
				<CustomLanguage key={"language"} style={{ top: pxToRem(40) }} />
			</div>
			<section>
				<div className={classes.loginWrap}>
					<Image
						src={require("@/assets/images/icons/logo.png")}
						width={pxToRem(100)}
						height={pxToRem(100)}
						placeholder={null}
					/>
					<h1>COIN GAMING</h1>
					{isCredits && <h2>CONSOLE</h2>}
				</div>

				<div className={classes.termsWrap}>
					<Image
						src={
							termsChecked
								? require("@/assets/images/icons/checked.png")
								: require("@/assets/images/icons/unchecked.png")
						}
						width={pxToRem(20)}
						height={pxToRem(20)}
						placeholder={null}
						onClick={() => {
							setTermsChecked(!termsChecked);
						}}
					/>
					<span>
						{t("IhaveAgree")}{" "}
						<em
							onClick={() => {
								setTermsVisible(true);
							}}
						>
							{t("TermsConditions")}
						</em>
					</span>
				</div>

				<Button
					className={classes.btn}
					shape="rounded"
					block
					onClick={login}
				>
					{isTelegram ? t("ConnectTelegram") : t("ConnectWallet")}
				</Button>

				<TermsPopup
					visible={termsVisible}
					onClose={() => setTermsVisible(false)}
				/>
			</section>

			<ApplyCenterPopup.PopupComp
				visible={ApplyCenterPopup.visiblePopup}
				onClose={ApplyCenterPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ApplyCenterPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<InvitationCode
					required={isCredits}
					inviteCode={invitationCode.current}
					onVisiblePopup={ApplyCenterPopup.closePopup}
					onSubmitCode={(code) => {
						console.log("邀请码:", code);
						invitationCode.current = code;
						continueLogin();
					}}
				/>
			</ApplyCenterPopup.PopupComp>
		</div>
	);
};

export default Login;

const useStyles = createUseStyles({
	loginPage: {
		position: "relative",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100vh",
		zIndex: 10,
		backgroundImage: `url(${require("@/assets/images/login/page_bg.png")})`,
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
	},
	loginWrap: {
		margin: "0 auto",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		paddingTop: pxToRem(20),

		"& > h1": {
			marginTop: pxToRem(18),
			fontWeight: 700,
			fontSize: pxToRem(24),
			color: "#fff",
			lineHeight: pxToRem(36),
		},
		"& > h2": {
			marginTop: pxToRem(2),
			fontWeight: 500,
			fontSize: pxToRem(16),
			color: "#fff",
			letterSpacing: pxToRem(7),
		},
	},
	termsWrap: {
		marginTop: pxToRem(74),
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontWeight: 400,
		paddingLeft: pxToRem(16),
		paddingRight: pxToRem(16),

		"& > span": {
			marginLeft: pxToRem(10),
			fontSize: pxToRem(12),
			color: "#fff",
			padding: "3px 0",

			"& > em": {
				color: "#81E8FF",
				textDecorationLine: "underline",
				textDecorationColor: "#81E8FF",
			},
		},
	},
	btn: {
		margin: "0 auto",
		marginTop: pxToRem(32),
		borderWidth: 0,
		boxShadow:
			"0px 10px 10px 1px #184DED4D, 0px 2px 4px 0px #00C2FF40 inset",
		width: pxToRem(228),
		height: pxToRem(50),
		background: "linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
		fontWeight: 700,
		fontSize: pxToRem(18),
		color: "#fff",
	},
});
